import { useCallback, useEffect } from 'react';

import ShareStoreDealsBackground from '../../images/share-store-deals-background.svg';
import TrashieLogo from '../../images/trashie-logo.webp';

import './MobileRedirect.scss';

const MOBILE_APP_SCHEME = 'trashie://';

/**
 * Converts the current URL to the mobile app deep link URL
 * Replaces the origin (https://app.trashie.io) with the app scheme (trashie://)
 * @returns {string} The deep link URL for the mobile app
 */
const getDeepLinkUrl = () => {
  const { pathname, search } = window.location;
  return `${MOBILE_APP_SCHEME}${pathname.slice(1)}${search}`;
};

const MobileRedirect = () => {
  const openApp = useCallback(() => {
    const deepLinkUrl = getDeepLinkUrl();
    window.location.href = deepLinkUrl;
  }, []);

  useEffect(() => {
    openApp();
  }, [openApp]);

  return (
    <div className="MobileRedirect">
      <img
        src={ShareStoreDealsBackground}
        alt="background"
        className="MobileRedirect__background"
        aria-hidden="true"
      />

      <div className="MobileRedirect__content">
        <div className="MobileRedirect__card">
          <img
            src={TrashieLogo}
            alt="Trashie"
            className="MobileRedirect__logo"
          />

          <div className="MobileRedirect__info">
            <h1 className="MobileRedirect__title">Opening Trashie App...</h1>
            <p className="MobileRedirect__subtitle">
              If the app didn&apos;t open, tap the button below.
            </p>
            <button
              type="button"
              className="MobileRedirect__button"
              onClick={openApp}
            >
              Open App
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileRedirect;
